import Refer from './refer'
import Comment from './comment'
import Status from './status'
import History from './history'
export default {
  name: 'checklist-item',
  components: {Refer, Comment, Status, History},
  props: ['checklist_items', 'checklist_item_status', 'group'],
  data () {
    return {
      select_status: {
        id: 0,
        code: 'All'
      }
    }
  },
  computed: {
    profile () {
      return this.$store.getters['Profile/getProfile']
    },
    filterChecklistItems () {
      if (this.select_status.id === 0) {
        return this.checklist_items
      } else {
        return this.checklist_items.filter(element => {
          return element.checklist_item_status.id === this.select_status.id
        })
      }
    },
    checklist () {
      return this.$store.getters['Checklist/showChecklist']
    }
  },
  mounted () {
  },
  methods: {
    start () {
      this.select_status = {
        id: 0,
        code: 'All'
      }
    },
    showComment (checklist_item = {}) {
      // console.log(checklist_item)
      this.$store.commit('Audit/openCommentOfChecklistItem', checklist_item)
      if (!checklist_item.open_comment) {
        return false
      }
    
      this.$store.dispatch('Comment/getListCommentOfChecklistItem', {checklist: {id: this.$route.params.checklist_id}, checklist_item}).then(res => {
        checklist_item.comments = res.cmts
        checklist_item.cmt_crv = res.cmt_crv
        this.$store.commit('Audit/addCommentToChecklistItem', checklist_item)
        
      }).catch(errors => {
        
      })
    },
    history (checklist_item = {}) {
    
      this.$store.dispatch('Audit/history', {checklist: {id: this.$route.params.checklist_id}, checklist_item}).then(res => {
        this.$refs.history.show(res)
        
      }).catch(errors => {
        
      })
    },
    setStatus (status) {
      this.select_status = status
    },
    showModalRefer (checklist_item = {}) {
    
      this.$store.dispatch('ChecklistItem/getReferDocument', {checklist_item}).then(res => {
        this.$refs.refer.show(res)
        
      }).catch(errors => {
        
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/view/checklist-item/checklist-item.js